<template>
  <ak-card-header class="flex flex--center">
    <div class="flex__item flex flex--center">
      <h4 class="color-grey">
        {{ leadsOwner }} {{ leadsAge }} {{ leadsBranding }}
      </h4>
      <i
        v-if="currentWidget === 'allLeads' || currentWidget === 'allNewLeads'"
        class="ml-tiny fa fa-solid fa-user-group"
      />
      <i
        v-if="currentWidget === 'myLeads' || currentWidget === 'myNewLeads'"
        class="ml-tiny fa fa-solid fa-user"
      />
      <ak-dropdown size="auto" aria-role="list" class="ml-tiny leads-dropdown">
        <template #trigger>
          <ak-button color="transparent" size="small" circle>
            <span class="caret"></span>
          </ak-button>
        </template>
        <template #default>
          <div
            v-if="currentWidget === 'allLeads' || currentWidget === 'myLeads'"
          >
            <ak-dropdown-item
              class="flex flex--center pt-0 pb-tiny px-tiny"
              @click="selectWidget('allLeads')"
            >
              <i class="fa fa-solid fa-user-group mr-tiny min-width-20" />
              <span class="text-nowrap">All {{ leadsBranding }}</span>
            </ak-dropdown-item>
            <ak-dropdown-item
              class="flex flex--center py-0 px-tiny"
              @click="selectWidget('myLeads')"
            >
              <i class="fa fa-solid fa-user mr-tiny min-width-20" />
              <span class="text-nowrap">My {{ leadsBranding }}</span>
            </ak-dropdown-item>
          </div>
          <div
            v-if="
              currentWidget === 'allNewLeads' || currentWidget === 'myNewLeads'
            "
          >
            <ak-dropdown-item
              class="flex flex--center pt-0 pb-tiny px-tiny"
              @click="selectWidget('allNewLeads')"
            >
              <i class="fa fa-solid fa-user-group mr-tiny min-width-20" />
              <span class="text-nowrap">All new {{ leadsBranding }}</span>
            </ak-dropdown-item>
            <ak-dropdown-item
              class="flex flex--center py-0 px-tiny"
              @click="selectWidget('myNewLeads')"
            >
              <i class="fa fa-solid fa-user mr-tiny min-width-20" />
              <span class="text-nowrap">My new {{ leadsBranding }}</span>
            </ak-dropdown-item>
          </div>
        </template>
      </ak-dropdown>
    </div>
    <div>
      <ak-tooltip :placement="'left'" :has-arrow="false">
        <template #trigger>
          <router-link :to="viewAllLeads">
            <ak-button circle size="small" color="transparent">
              <i class="color-primary icon-open" />
            </ak-button>
          </router-link>
        </template>
        View All
      </ak-tooltip>
      <ak-tooltip :placement="'left'" :has-arrow="false">
        <template #trigger>
          <ak-button
            circle
            size="small"
            color="transparent"
            @click="changeWidget()"
          >
            <i class="color-grey-light icon-cog" />
          </ak-button>
        </template>
        Change Widget
      </ak-tooltip>
    </div>
  </ak-card-header>
  <ak-card-body :size="'flush'" class="flex--column overflow-y h-full">
    <ak-display-table v-if="isLoading" cosy>
      <ak-display-table-row
        v-for="number in n"
        :key="number"
        class="c-skeleton-loading"
      >
        <ak-display-table-cell class="width-40">
          <div
            class="circle circle--large bg-grey-lighter c-skeleton-loading__item"
          ></div>
        </ak-display-table-cell>
        <ak-display-table-cell>
          <ak-pack>
            <ak-pack-item>
              <div class="c-faux-text width-125" />
              <div>
                <p class="c-faux-text width-100 mb-none"></p>
              </div>
            </ak-pack-item>
          </ak-pack>
        </ak-display-table-cell>
        <ak-display-table-cell class="cell--1">
          <div class="c-faux-text width-50" />
          <div class="c-faux-text width-50" />
        </ak-display-table-cell>
      </ak-display-table-row>
    </ak-display-table>
    <div
      v-if="
        !isLoading &&
        !leads.length &&
        display('show', 'accountadmin,accountuser,reporter')
      "
      class="one-whole h-full flex flex--column flex--center flex--justify-center pb"
    >
      <div class="flex flex--column flex--center">
        <i class="icon--huge icon-leads color-grey-light mb-small"></i>
        <h3 class="color-grey mb-tiny">Start capturing {{ leadsBranding }}</h3>
        <p>
          Why not build a
          <router-link
            class="text-link text-link-hover"
            :to="{ name: 'appsList', params: { type: 'all', cat: 'forms' } }"
            >form</router-link
          >
          or
          <router-link
            class="text-link text-link-hover"
            :to="{ name: 'appsList', params: { type: 'all', cat: 'pages' } }"
          >
            landing page</router-link
          >
          to start capturing {{ leadsBranding }}
        </p>
      </div>
    </div>

    <ak-table
      v-if="
        !isLoading &&
        ((leads.length &&
          display('show', 'accountadmin,accountuser,reporter')) ||
          display('hide', 'accountadmin,accountuser,reporter'))
      "
      v-model:data="leads"
      hide-head
      hoverable
      background
      spacing="tiny"
      :empty-state="emptyState"
      :class="{ 'h-full flex': !leads.length }"
    >
      <template #default="{ row }">
        <ak-table-column :width="40">
          <router-link :to="viewLead(row)" @click="row.clicked = true">
            <div :class="{ 'p-tiny': row.clicked, 'p-small': !row.clicked }">
              <div v-if="row.clicked" class="avatar-wrapper">
                <ak-loading-spinner :size="'small'" />
              </div>
              <div v-if="!row.clicked" class="avatar-wrapper">
                <ak-avatar
                  v-if="row.displayData !== false && !row.suppressed"
                  :string="row.name"
                  :size="38"
                />
                <ak-avatar
                  v-if="row.displayData === false"
                  :string="'–'"
                  :size="38"
                />
                <ak-tooltip
                  v-if="row.suppressed && row.displayData !== false"
                  theme="light"
                  :placement="'right'"
                >
                  <template #trigger>
                    <div class="avatar avatar--initial-replacement bg-warning">
                      <i class="icon-warning icon--big mb-micro"></i>
                    </div>
                  </template>
                  <div class="flex flex--column max-width-300">
                    <strong class="mb-micro color-warning">
                      Globally Suppressed
                    </strong>
                    <p class="text-small mb-0">
                      This {{ leadsBrandingSingle }} is Globally suppressed as
                      they have clicked on the unsubscribe link within an
                      {{ !isXEquals() ? 'Akero' : 'XEquals' }} email. They will
                      no longer receive any non-transactional emails that you
                      send via {{ !isXEquals() ? 'Akero' : 'XEquals' }}.
                    </p>
                  </div>
                </ak-tooltip>

                <ak-tooltip
                  v-if="
                    !row.contactId && row.displayData && isAllowed('contacts')
                  "
                  class="absolute absolute--bottom"
                  :placement="'right'"
                  :x-axis="-6"
                  :has-arrow="false"
                >
                  <template #trigger>
                    <div
                      class="avatar-badge avatar-badge--bottom-right badge badge--danger badge--notification"
                    ></div>
                  </template>
                  No Contact Exists
                </ak-tooltip>
                <ak-tooltip
                  v-if="
                    row.agencyLead === true &&
                    row.displayData === true &&
                    display('show', 'developer')
                  "
                  :placement="'right'"
                  :x-axis="-6"
                  :has-arrow="false"
                >
                  <template #trigger>
                    <div
                      class="avatar-badge avatar-badge--bottom-right badge badge--grey-light badge--notification"
                    ></div>
                  </template>
                  Generated From Agency Campaign
                </ak-tooltip>
                <ak-tooltip
                  v-if="row.displayData === true && row.duplicate"
                  class="absolute absolute--bottom"
                  :x-axis="-6"
                  :placement="'right'"
                  :has-arrow="false"
                >
                  <template #trigger>
                    <div
                      class="avatar-badge avatar-badge--bottom-right badge badge--quaternary badge--notification"
                    ></div>
                  </template>
                  Duplicate
                </ak-tooltip>
              </div>
            </div>
          </router-link>
        </ak-table-column>
        <ak-table-column>
          <router-link :to="viewLead(row)" @click="row.clicked = true">
            <div class="flex flex--column">
              {{ row.name || 'No Name Given' }}
              <br />
              <span v-if="row.formFields.email" class="text-small">
                <strong v-if="row.suppressed" class="color-warning"
                  >Suppressed: </strong
                >{{ row.formFields.email.value }}
              </span>
              <span v-if="!row.formFields.email" class="text-small"> – </span>
            </div>
          </router-link>
        </ak-table-column>
        <ak-table-column
          field="row.createdOn"
          class="text-nowrap text-small px cell--1"
        >
          <router-link :to="viewLead(row)" @click="row.clicked = true">
            <strong>{{ formatDate(row.createdOn) }}</strong>
            <br />
            <em>{{ formatTime(row.createdOn) }}</em>
          </router-link>
        </ak-table-column>
      </template>
    </ak-table>
  </ak-card-body>
</template>

<script>
import { accountObj, agencyObj, userObj } from '@akerolabs/akero-vue/src/store'
import { isXEquals } from '@akerolabs/akero-vue/src/services/agency'
import { defineComponent, ref, computed, onMounted } from 'vue'
import { display } from '@akerolabs/akero-vue/src/services/users'
import { entityBranding } from '@akerolabs/akero-vue/src/services/entityBranding.js'
import { isAllowed } from '@akerolabs/akero-vue/src/services/features.js'
import { ToastProgrammatic } from '@akerolabs/akero-vue/src'
import { request } from '@akerolabs/akero-vue/src/utils/request'
import Avatar from '@akerolabs/akero-vue/src/components/avatar/Avatar.vue'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import CardHeader from '@akerolabs/akero-vue/src/components/cards/CardHeader.vue'
import CardBody from '@akerolabs/akero-vue/src/components/cards/CardBody.vue'
import date from '@akerolabs/akero-vue/src/utils/date'
import LoadingSpinner from '@akerolabs/akero-vue/src/components/loading/LoadingSpinner.vue'
import Popover from '@akerolabs/akero-vue/src/components/popover/Popover.vue'
import Table from '@akerolabs/akero-vue/src/components/table/Table.vue'
import TableColumn from '@akerolabs/akero-vue/src/components/table/TableColumn.vue'
import { userLevelIsHigerThan } from '@akerolabs/akero-vue/src/services/users.js'

export default defineComponent({
  name: 'AkWidgetLeads',

  components: {
    [Avatar.name]: Avatar,
    [Button.name]: Button,
    [CardHeader.name]: CardHeader,
    [CardBody.name]: CardBody,
    [LoadingSpinner.name]: LoadingSpinner,
    [Popover.name]: Popover,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  inheritAttrs: false,

  props: {
    /**
     * @type {Object}
     * @description Age of leads (new)
     */
    age: {
      default: '',
      type: String,
    },
    /**
     * @type {Function}
     * @description change widget function
     */
    changeWidget: {
      default: () => ({}),
      type: Function,
    },
    /**
     * @type {}
     * @description current widget name
     */
    currentWidget: {
      default: '',
      type: String,
    },
    /**
     * @type {String}
     * @description who leads/contacts belong to
     */
    owner: {
      default: 'all',
      type: String,
    },
  },

  setup(props) {
    let n = 10
    const leadsOwner = ref('')
    const leadsAge = ref('')
    const leads = ref([])
    const isLoading = ref(true)
    const userObject = ref(null)
    const isAllowedContacts = ref(null)

    /**
     * @param {*} widget
     * @description Changes widget to another
     */
    const selectWidget = (widget) => {
      props.changeWidget(widget)
    }
    /**
     * @description Route to leads table
     */
    const viewAllLeads = computed(() => {
      return { name: 'leads.manager.singleContainer.all' }
    })
    /**
     *
     * @param {*} options
     * @description route to leads/contacts
     */
    const viewLead = (lead) => {
      if (!lead.deleted) {
        if (
          lead.contactId &&
          isAllowedContacts.value &&
          userObject.value.viewAssignedContactsOnly
        ) {
          if (!lead) return false
          let isOwn
          isOwn = isOwnContact(lead.contactId)

          if (!isOwn) {
            return ''
          }

          let id
          id = lead.contactId

          if (lead.contactId && lead.contactId._id) {
            id = lead.contactId._id
          }

          let params = {
            id: id,
            _id: lead._id,
          }

          return {
            name: 'contact.manager.contact.view.leads',
            params: { ...params },
          }
        }
        if (!lead) return false
        return {
          name: 'leads.manager.singleContainer.viewAll.leads',
          params: { leadId: lead._id },
        }
      }
    }
    const isOwnContact = (contact) => {
      try {
        if (userObj().viewAssignedContactsOnly) {
          return contact && contact.owner === userObj()._id
        }
        return true
      } catch (ex) {
        console.log(ex)
        return true
      }
    }
    /**
     * @description User defined lead branding
     */
    const leadsBranding = computed(() => {
      return entityBranding('leads.plural', 'Leads')
    })
    /**
     * @description User defined lead branding (single)
     */
    const leadsBrandingSingle = computed(() => {
      return entityBranding('leads.singular', 'Lead')
    })
    /**
     * @description Makes an api request to request leads for account/agency
     */
    const fetchLeads = async () => {
      let leadsData = []
      const displayError = (ex) => {
        if (ex) console.log(ex)
        ToastProgrammatic.open({
          message: `Error failed to load requests`,
          type: 'danger',
        })
      }
      try {
        const { data } = await request.get('/leads', leadsRequest.value)
        leadsData = data.data
      } catch (ex) {
        leadsData = []
        displayError(ex)
      }
      leads.value = leadsData
      isLoading.value = false
    }
    /**
     * @description params for fetchLeads()
     */
    const leadsRequest = computed(() => {
      let params = {
        account: accountObj()._id,
        agency: agencyObj()._id,
        deleted: JSON.stringify({ $ne: true }),
        test: JSON.stringify({ $ne: true }),
        isSpam: JSON.stringify({ $ne: true }),
        status: JSON.stringify({ $nin: ['spam'] }),
        populate: 'contactId',
      }
      if (props.owner === 'my') {
        params['assignee._id'] = userObj()._id
      }
      if (props.age === 'new') {
        params.status = 'new'
      }
      return {
        params,
      }
    })

    /**
     *
     * @param {*} dateString
     * @description format createdOn into DD/MM/YYYY
     */
    const formatDate = (dateString) => {
      return date(dateString).format('DD/MM/YY')
    }

    /**
     *
     * @param {*} dateString
     * @description format createdOn into HH:MM
     */
    const formatTime = (dateString) => {
      return date(dateString).format('h:mm a')
    }

    /**
     *
     * @description Create string for empty state depending on props
     */
    const emptyStateText = () => {
      let first =
        props.owner === 'my'
          ? 'You currently have no '
          : 'There are currently no '
      let second = props.age === 'new' ? 'new ' : ''
      return (
        first +
        second +
        entityBranding('leads.plural', 'Leads') +
        ' on this account'
      )
    }

    /**
     *
     * @description Create empty state for table
     */
    const emptyState = {
      title: userLevelIsHigerThan('agencyuser')
        ? entityBranding('leads.plural', 'Leads')
        : '',
      icon: userLevelIsHigerThan('agencyuser') ? 'leads' : '',
      text: userLevelIsHigerThan('agencyuser') ? emptyStateText() : '',
    }

    /**
     * @description onMount set leadsOwner, fetch leads for widget table
     */
    onMounted(async () => {
      userObject.value = userObj()
      isAllowedContacts.value = isAllowed('contacts')

      if (props.age === 'new') {
        leadsAge.value = 'New'
      }
      if (props.owner === 'all') {
        leadsOwner.value = 'All'
      }
      if (props.owner === 'my') {
        leadsOwner.value = 'My'
      }
      await fetchLeads()
    })
    return {
      display,
      fetchLeads,
      formatDate,
      formatTime,
      isAllowed,
      isXEquals,
      leads,
      leadsAge,
      leadsBranding,
      leadsBrandingSingle,
      leadsOwner,
      isLoading,
      selectWidget,
      viewAllLeads,
      viewLead,
      n,
      emptyState,
    }
  },
})
</script>

<style lang="scss">
@import '@akerolabs/akero-vue/src/scss/_settings.scss';
.leads-dropdown {
  .ak-dropdown__body {
    padding: $spacing-small $spacing-tiny;
  }
}
</style>
